import { render, staticRenderFns } from "./gravitationDialog.vue?vue&type=template&id=68e18e80&"
import script from "./gravitationDialog.vue?vue&type=script&lang=js&"
export * from "./gravitationDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports